module.exports = __webpack_public_path__ + "assets/img/rank2.79d1a1b2.png";